export const VERSION = '4.72.0'; // x-release-please-version
